import { take, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { ContractsService } from '../../../services/contracts.service';


@Injectable({
  providedIn: 'root'
})
export class ResolveCanceledService implements Resolve<any> {

  constructor(
    private contractService: ContractsService) { }

  resolve(): Observable<any> {
    return this.contractService.pageAll(10,1, 'dataFinalizacao').pipe(
      take(1),
      mergeMap(teste => {
        return of(teste['object']);
      })
    );
  }

}
